<template>
    <table>
        <thead>
            <tr>
                <th v-for="column, index in columns" :key="index" @click.prevent="setSortBy(column)">
                    {{ column.text }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="element in _elements" :key="element.id">
                <td v-for="{ attribute, icon, method, logo, type, role, state }, i in columns" :key="i"
                    :class="{ 'logoUrl': logo }">
                    <router-link :to="destination(element)">
                        <span class="btn" v-if="logo">
                            <img v-if="type == 'image'" :src="element[logo]" />
                        </span>
                        <span v-text="element[attribute]"
                            v-if="element[attribute] + element[icon] + element[role]"></span>
                        <span v-if="element[state]" v-text="element[attribute] ? 'Finalizado' : 'A Decorrer'"></span>
                        <span @click.prevent="handleActionClick(element, method)" class="btn" v-else-if="icon">
                            <IconComponent class="icon" :icon="icon" />
                        </span>
                    </router-link>
                </td>
                <PopupComponent v-show="popupVisible" @cancel="popupVisible = false"
                    :name="popupElement ? popupElement.name : ''" :options="option" @execute="deleteObj()" />
            </tr>
        </tbody>
    </table>
</template>

<script>
import IconComponent from '@/components/Icons.vue'
import PopupComponent from './popups/Delete.vue';

export default {
    name: 'TableComponent',
    components: {
        PopupComponent,
        IconComponent,
    },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        elements: {
            type: Array,
            required: true,
        },
        destination: {
            required: true,
        },
        option: {
            required: false,
        },
    },
    data() {
        return {
            popupVisible: false,
            popupMethod: null,
            popupElement: null,
            sortBy: null,
            sortAsc: true,
        };
    },
    methods: {
        deleteObj() {
            try {
                this.popupMethod(this.popupElement)
                this.popupVisible = false
            } catch (error) {
                console.log(error)
            }
        },
        handleActionClick(element, method) {
            try {
                this.$emit('action-click', element.id)
                this.popupVisible = true
                this.popupMethod = method
                this.popupElement = element

            } catch (error) {
                console.log(error)
            }
        },
        setSortBy(column) {
            if (this.sortBy != column) {
                this.sortBy = column
                this.sortAsc = true
                return
            }
            if (this.sortBy == column && !this.sortAsc) {
                this.sortBy = null
            }
            this.sortAsc = false
        },
    },
    computed: {
        _elements() {
            if (!this.sortBy) {
                return this.elements;
            }
            return [...this.elements].sort((a, b) => {
                const aValue = a[this.sortBy.attribute] || ''
                const bValue = b[this.sortBy.attribute] || ''
                const compare = aValue.localeCompare(bValue)
                return this.sortAsc ? compare : 0 - compare
            });
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

table {
    width: 100%;
    border: 1px solid none;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--card-bg);
    box-shadow: 0px 4px 8px rgba(var(--black), 0.1);

    tr {

        th {
            padding: 15px 10px;
            font-weight: 600;
            color: var(--text-color);
            text-align: left;
            font-size: .9rem;
            text-transform: uppercase;
            cursor: pointer;
        }

        td {
            padding: 15px 10px;
            font-weight: 500;
            text-align: left;
            color: var(--secondary-color);
            font-size: 1rem;
            vertical-align: middle;
            margin: auto;

            &:last-child {
                text-align: center;
            }

            .btn {
                background: none;
                cursor: pointer;
                border: none;
                display: inline-flex;
                align-items: center;

                .icon {
                    width: 18px;
                    height: 18px;
                    fill: var(--text-color);
                    transition: fill 0.3s;
                    margin-left: auto;

                    &:last-child {
                        display: flex;
                        align-items: left;
                        justify-content: right;
                    }

                }
            }
        }
    }
}
</style>
